const translations = {
  "en": {
    "This is just my read from our first meeting — the more time we spend, the sharper it gets. So, where do we start?": "This is just my read from our first meeting — the more time we spend, the sharper it gets. So, where do we start?",
    "What do you want to crack first?": "What do you want to crack first?"
  },
  "zh-tw": {
    "This is just my read from our first meeting — the more time we spend, the sharper it gets. So, where do we start?": "這只是我們第一次聊完的初步判斷 — 聊得越多，它就越準。那，我們從哪開始？",
    "What do you want to crack first?": "你想先深入分析什麼？"
  }
};

export default translations;
